import type { RiskLevel } from '@nestjs-boilerplate/types';

import { cn } from '@/lib/utils';

interface RiskLevelBadgeProps {
  level: RiskLevel;
}

const riskLevelStyles: Record<RiskLevel, string> = {
  LOW: 'bg-emerald-100 text-emerald-800',
  MEDIUM: 'bg-amber-100 text-amber-800',
  HIGH: 'bg-red-100 text-red-800',
  CRITICAL: 'bg-red-900 text-white',
};

const riskLevelLabels: Record<RiskLevel, string> = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  CRITICAL: 'Critical',
};

export function RiskLevelBadge({ level }: RiskLevelBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-[14px] font-medium',
        riskLevelStyles[level],
      )}
    >
      {riskLevelLabels[level]}
    </span>
  );
}
